const options = {
  distractionFree: false,
  valueAsInteger: false,
  autoDecimalMode: true,
  currency: null,
  locale: 'pt-br'
}

module.exports = options
